/**
 *
 * StudentRow
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form } from 'react-bootstrap';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import useVideoEnabled from 'components/VideoConf/useVideoEnabled.js';
import EditButton from 'components/interaction/EditButton.js';
import messages from './messages.js';
import useSelectLocationType from '../SelectLocationType/useSelectLocationType.jsx';

const MeetNr = styled.span`
  font-weight: bold;
  &::after {
    content: ':';
    margin-right: 0.5rem;
  }
`;

function StudentRow(props) {
  const [enabled] = useVideoEnabled();
  const { studentState, onEdit, onCheck, onOpenSelect, onSelectType, selectTypeId, defaultMeetingLocationType } = props;
  const intl = useIntl();
  const showLocationType = useSelectLocationType();
  const { student, checked, meetings, canChange } = studentState;
  const parents = student.connections;
  if (!meetings || meetings.length === 0) {
    return (
      <tr>
        <td className="text-muted" colSpan="4">
          <Form.Check type="checkbox" disabled label={<AvatarWithText src={student.avatar}>{student.displayName}</AvatarWithText>} />
        </td>
      </tr>
    );
  }
  const title = canChange ? '' : intl.formatMessage(messages.hasMeetings);
  const rows = meetings.length;

  const handleChange = (meeting) => {
    const { id, meetingLocationType } = meeting;
    onSelectType(id, meetingLocationType);
    onOpenSelect(0);
  };

  return meetings.map((mt, idx) => (
    <tr key={mt.id} title={title}>
      {idx === 0 && (
        <td rowSpan={rows}>
          <Form.Check
            checked={checked}
            onChange={(ev) => onCheck(ev.target.checked)}
            disabled={!canChange}
            label={<AvatarWithText src={student.avatar}>{student.displayName}</AvatarWithText>}
          />
        </td>
      )}
      {enabled && (
        <td>
          {showLocationType({
            meeting: mt,
            defaultMeetingLocationType,
            onEdit: () => onOpenSelect(mt.id),
            showEdit: selectTypeId === mt.id,
            onChange: handleChange,
          })}
        </td>
      )}
      <td className="text-end small">
        {meetings.length > 1 && (
          <MeetNr>
            <FormattedMessage {...messages.meeting} />
            {' '}
            {idx + 1}
          </MeetNr>
        )}
        {mt.parentIds.map((p) => parents[p].displayName).join(', ')}
      </td>
      {idx === 0 && (
        <td rowSpan={rows} className="px-0">
          <EditButton onClick={() => onEdit(student.id)} />
        </td>
      )}
    </tr>
  ));
}

StudentRow.propTypes = {
  studentState: PropTypes.object,
  defaultMeetingLocationType: PropTypes.number,
  selectTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onEdit: PropTypes.func,
  onCheck: PropTypes.func,
  onOpenSelect: PropTypes.func,
  onSelectType: PropTypes.func,
};

export default StudentRow;
